// extracted by mini-css-extract-plugin
module.exports = {"deleted":"LogoReport_deleted_2VBRR","holder":"LogoReport_holder_110yJ"};